import React, { useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthService } from '../../services/AuthService';

function Signout() {
    const navigate = useNavigate();
    const authService = new AuthService();

    useLayoutEffect(() => {
        authService.signoutRedirectCallback()
        .then(function () {
            navigate('/');
        }).catch(function (e) {
            console.error(e);
        });
    }, []);
    
    return (      
        <div>Logging out</div>
    );
}
  
export default Signout;